export const GET_USERS = "admin/GET_USERS";
export const GET_USERS_SUCCESS = "admin/GET_USERS_SUCCESS";
export const GET_USERS_FAILURE = "admin/GET_USERS_FAILURE";
